import { render, staticRenderFns } from "./Explainer.vue?vue&type=template&id=0ffa8162&scoped=true&"
import script from "./Explainer.vue?vue&type=script&lang=js&"
export * from "./Explainer.vue?vue&type=script&lang=js&"
import style0 from "./Explainer.vue?vue&type=style&index=0&id=0ffa8162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa8162",
  null
  
)

export default component.exports